module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av472-b55f86ef954a35223e98c432b4d1cf16.jpg";